module.exports = "/_next/static/images/CreateYourDynamicData@2x-8228aa7ece53bb2a6bac74ce28ab918f.webp";